/**
 * Verification receipt — the check chips collapse into this persistent
 * summary: "✓ 2 quotes verified · ✎ 1 lexicon corrected · ✓ refs
 * confirmed". Rendered during the show's curtain call and again on the
 * final message (the receipt survives the typeset).
 */

import type { ReceiptItem } from '@state/chat';

const ICON: Record<ReceiptItem['kind'], string> = {
  verified: '✓',
  corrected: '✎',
  confirmed: '✓',
};

export function VerificationReceipt({ items }: { items: ReceiptItem[] }) {
  if (items.length === 0) return null;
  return (
    <div className="verification-receipt" data-testid="verification-receipt">
      {items.map((item, i) => (
        <span key={i} className={`verification-receipt-item verification-receipt-item--${item.kind}`}>
          <span aria-hidden="true">{ICON[item.kind]}</span> {item.label}
          {i < items.length - 1 && <span className="verification-receipt-sep" aria-hidden="true"> · </span>}
        </span>
      ))}
    </div>
  );
}
